import moment from "moment"
import { decrypt } from "./crypto"

export const getPercentage=(data)=>{
  if(data.totalContent!==null && data.totalContent!==0){
    let percentage=  data?.progressStatus ? (data?.progressStatus?.score/data.totalContent) *100 : 0
    if(percentage<99){
      let per= Math.ceil(percentage)
      return per
     }
     else{
         return percentage
     }
  }
   return 0
}
export const getProgressPercentage=(data)=>{
  let percentage=  data.duration ? (data.duration.duration*100)/data.duration : 0
       return percentage
   
}
export const getVideoProgressPercentage=(data)=>{
  if(data.progress!==null){
    let percentage=  data.progress? (data?.progress.duration[0]?.duration*100)/data?.duration :0
         return percentage
  } 
  return 0  
}
export const getProgressVideoPercentage=(data)=>{
  let percentage
  (data.video&& data.video.videoUrls)&& data.video.videoUrls.map(obj=>{ 
    if(obj.language===JSON.parse(localStorage.getItem('language')) &&  data?.video?.progress?.duration!==null && data?.video?.progress?.duration[0].language===JSON.parse(localStorage.getItem('language'))){
        if(data.video.progress&&data.video.progress.isCompleted==true){
          percentage=100
        }
        else if(data.video.progress&&data.video.progress.isCompleted!==true && data?.video?.progress?.duration[0].language === JSON.parse(localStorage.getItem('language'))){
          percentage= ((data?.video?.progress?.duration&&data?.video?.progress?.duration[0]?.duration/1000)/(obj.duration)*100)
        }
      }
      else if(data.video.videoUrls.length===1 && data?.video?.progress?.duration!==null){
       if(data?.video?.progress&&data?.video?.progress?.isCompleted!==true && data?.video?.progress?.duration[0].language !== JSON.parse(localStorage.getItem('language'))){
          percentage= ((data?.video?.progress?.duration&&data?.video?.progress?.duration[0]?.duration/1000)/(obj.duration)*100)
        }
      }
      })
      return percentage
      }

export const getTime=(data)=>{
        const hours = Math.floor(parseInt(data?data?.duration:0) / 3600);
        const minutes = Math.floor(parseInt(data?data?.duration:0) / 60);
        return (
          ("00" + hours).slice(-2) +
          ":" +
          ("00" + minutes).slice(-2) +
          ":" +
          ("00" + Math.floor(parseInt(data?data?.duration:0) - minutes * 60)).slice(-2)
        );
}
export const getVideoTime=(data)=>{
  let time
  if(data?.videoUrls?.length!==0){
    data&&data?.videoUrls?.filter(obj=>{
      if(data?.videoUrls?.length > 1){
        if(obj?.language===JSON.parse(localStorage.getItem('language')))
        time= new Date(obj?.duration * 1000).toISOString().slice(11, 19);
      }
      else if(data?.videoUrls?.length ==1){
        time= new Date(obj?.duration * 1000).toISOString().slice(11, 19);
      }
    })
  }
  else{
    time= new Date(data?.duration * 1000).toISOString().slice(11, 19);
  }
  return time

}
export const getfreeVideoTime=(data)=>{
  let time
  data&&data.videoUrls.filter(obj=>{
    if(data.videoUrls.length > 1){
      if(obj.language===JSON.parse(localStorage.getItem('language')))
      time= new Date(obj.duration * 1000).toISOString().slice(11, 19);
    }
    else if(data.videoUrls.length ==1){
      time= new Date(obj.duration * 1000).toISOString().slice(11, 19);
    }
  })
  return time
}

export const getTestTime=(data)=>{
  const hours = Math.floor(parseInt(data&&data.duration) / 60);
  return (
    ("00" + hours).slice(-2) +
    ":" +
    ("00" +  Math.floor(parseInt(data&&data.duration) - hours * 60)).slice(-2) +
    ":" +
    ("00" +'00').slice(-2) 
  );
}

export const transform=(value)=> {
 
    const hours = Math.floor(value / 3600);
    const minutes = Math.floor((value % 3600) / 60);
    return (
      ("00" + hours).slice(-2) +
      ":" +
      ("00" + minutes).slice(-2) +
      ":" +
      ("00" + Math.floor(value - minutes * 60)).slice(-2)
    );
  }

export const trimText=(data)=>{
let result = data.description.slice(0,75);
    return result

}

export const getTopicIndex=(data)=>{
     data.map((d,i)=>{
       if(d.title==="Topic"){
         return i
       }
     })
  }

  export const getqbPercentage=(data)=>{  //qb
    let percentage=  data&&data.progress ? (data.progress.questions.length/data.questionIds.length) *100 : 0
      // return percentage

    if(percentage<99){
      let per= Math.round(percentage)
      return per
     }
     else{
      return percentage
     }
     
  }

  export const getTestPercentage=(data)=>{ //test
    if(data&&data.progress && data.progress.isCompleted==true){
     return 100
    }
    else{
      let percentage=  data&&data.progress ? (data.progress.attemptedQuesCount/data.questionCount) *100 : 0
      if(percentage<99){
        let per= Math.round(percentage)
        // console.log(per)
        return per
       }
       else{
        //  console.log(percentage)
        return percentage
       }
    }
  }

  export const getStatus = (data)=>{  // test

    if(new Date(data&&data.schedule) > new Date()){
      return 'upcoming'
    }else if((new Date(data&&data.schedule) < new Date() && new Date()<= new Date(data&&data.endTest))){
      return 'live';
    }
    else{
      return 'expire'
    }
  }

  export const getQbProgressPercentage =(data)=>{
    let per
    data.options.map(obj=>{
      if((data?.answer[0]).toString()===(obj._id).toString()){
        per =  Math.round((obj?.optionAttempt*100)/data?.totalAttemptCount)>0? Math.round((obj.optionAttempt*100)/data.totalAttemptCount):0
      }
    })
    return per
  }

  export const testPerformanceTest = (data)=>{
    let per=((data?.marks/data?.totalMarks)*100)>0?Math.round((data?.marks/data?.totalMarks)*100):0
    return per
  }

  
  export function getLocalStorage(key=""){
    if(key){
      return localStorage.getItem(key) ? JSON.parse(decrypt(localStorage.getItem(key))) : {}
    }  
  }

  export function getLocalStorageQuestions(key=""){
    if(key){
      const questions=localStorage.getItem(key) ? JSON.parse(localStorage.getItem(key)) : []
      return questions
    }  
  }

   export function setLocalStorage(key="",value={}){
    if(key){
     localStorage.setItem(key,JSON.stringify(value))
    } 
  }
